import { Component, OnInit, ViewChild, ElementRef, Renderer2, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.sass']
})
export class MessageComponent implements OnInit {
  @ViewChild('message', {read: ElementRef}) message;
  @ViewChild('more', {read: ElementRef}) more;
  @Input() single_message: object;
  @Input() totalMessages: number;

  @Output() reloadMessageData = new EventEmitter();

  open = false
  deleted = false
  constructor( private renderer: Renderer2, private apiService: ApiService) { }

  ngOnInit(): void {
  }

  messageShow() {
    if (this.open === false) {
      this.message.nativeElement.style.display = "flex"
      this.renderer.addClass(this.more.nativeElement, "more")
      this.open = true
    }

    else {
      this.message.nativeElement.style.display = "none"
      this.renderer.removeClass(this.more.nativeElement, "more")
      this.open = false 
    }
  }

  deleteMessage(val) {
    this.deleted = true
    this.apiService.deleteMessage(val).subscribe(data => this.reloadMessageData.emit())

  }
}
